import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import styles from './VerificationLoader.module.css';

/**
 * VerificationLoader Component
 * A beautiful, animated loader that transitions from a spinner to a checkmark
 * @param {boolean} isVerified - Whether verification is complete
 * @param {string} message - Message to display below the loader
 */
function VerificationLoader({
  isVerified = false,
  verificationMessage,
  verifyEmail,
  isLoading = false,
  from,
}) {
  const messageType = verificationMessage?.type || 'waiting';
  const isWaiting = messageType === 'waiting';
  const isSuccess = messageType === 'success';
  const isError = messageType === 'error';
  console.log('from in loader', from);

  return (
    <div className={styles.container}>
      <div className={styles.messageContainer}>
        <p
          className={`${styles.message} ${
            isSuccess ? styles.successMessage : ''
          } ${isError ? styles.errorMessage : ''}`}
        >
          {verificationMessage?.message}
        </p>

        {isWaiting && (
          <div className={styles.dotsAnimation}>
            <span className={styles.dotAnim} style={{ '--dot-delay': '0s' }}>
              .
            </span>
            <span className={styles.dotAnim} style={{ '--dot-delay': '0.3s' }}>
              .
            </span>
            <span className={styles.dotAnim} style={{ '--dot-delay': '0.6s' }}>
              .
            </span>
          </div>
        )}
      </div>
      {isWaiting && (
        <div className={styles.infoText}>
          We have sent a magic link to
{' '}
          {localStorage.getItem('loginEmailNewUser')}
. Please verify by clicking
          on the link to continue. Please check spam folder if primary inboxes
          doesn&apos;t show them.
        </div>
      )}
      <div className={styles.loaderWrapper}>
        {isError ? (
          <div className={styles.errorContainer}>
            <div className={styles.errorIconWrapper}>
              <ErrorIcon className={styles.errorIcon} />
              <div className={styles.errorGlow} />
            </div>
          </div>
        ) : isWaiting ? (
          <div className={styles.spinner} />
        ) : isSuccess ? (
          <div className={styles.successContainer}>
            <div className={styles.checkmarkWrapper}>
              <CheckCircleIcon className={styles.checkmark} />
              <div className={styles.successGlow} />
            </div>
            {from !== 'web' && (
              <div>
                <div className={styles.goToAppText}>
                  Please return to the app to continue.
                </div>
                <div className={styles.goToAppText}>OR</div>
              </div>
            )}
            <button
              onClick={verifyEmail}
              className={styles.proceedButton}
              disabled={isLoading}
            >
              {isLoading ? (
                <span className={styles.buttonLoader}>
                  <span className={styles.buttonSpinner} />
                  Loading...
                </span>
              ) : from !== 'web' ? (
                'Access account here'
              ) : (
                'Proceed to Login'
              )}
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default VerificationLoader;
